export {default as HeadMetadata} from './headMetadata'
